const configuredApiBaseUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.REACT_APP_BACKEND_URL
    ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")}/api`
    : "http://localhost:9001/api");

const currentHostname =
  typeof window !== "undefined" ? window.location.hostname : "";

const isLocalFrontendHost =
  currentHostname === "localhost" || currentHostname === "127.0.0.1";

const localDevApiBaseUrl = "http://localhost:9001/api";

// In local frontend development, always prefer the local backend even if an old
// env value or cached bundle still points to production.
export const API_BASE_URL = (
  isLocalFrontendHost ? localDevApiBaseUrl : configuredApiBaseUrl
).replace(/\/$/, "");
